var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.workshop.paintHourlyBillingRate'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.localDetails.hourlyBillingRatePaintFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "hourlyBillingRatePaintFormable", _vm._n($$v));
      },
      expression: "localDetails.hourlyBillingRatePaintFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.workshop.paintMaterialPercentage'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.isRelativeValueRule
    },
    model: {
      value: _vm.localDetails.paintMaterialPercentageFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "paintMaterialPercentageFormable", _vm._n($$v));
      },
      expression: "localDetails.paintMaterialPercentageFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.workshop.mechanicalHourlyBillingRate'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    model: {
      value: _vm.localDetails.hourlyBillingRateMechanicalFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "hourlyBillingRateMechanicalFormable", _vm._n($$v));
      },
      expression: "localDetails.hourlyBillingRateMechanicalFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.workshop.sparePartsDiscountPercentage'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.isRelativeValueRule
    },
    model: {
      value: _vm.localDetails.sparePartsDiscountFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "sparePartsDiscountFormable", _vm._n($$v));
      },
      expression: "localDetails.sparePartsDiscountFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.workshop.sparePartsSurchargePercentage'),
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.isRelativeValueRule
    },
    model: {
      value: _vm.localDetails.sparePartsSurchargeFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "sparePartsSurchargeFormable", _vm._n($$v));
      },
      expression: "localDetails.sparePartsSurchargeFormable"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }